import React, { FC, useEffect, useState } from 'react'
import { Layout } from 'components/Layout'
import ProductEditCompleteTemplate from 'components/Templates/product/ProductEditCompleteTemplate'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { db } from 'firebase/index'

const ProductEditComplete: FC = () => {
  const path = useSelector((state: State) => state.router.location.pathname)
  const isEditPage = /\/product\/edit\/complete\/.+/.test(path)
  const id = isEditPage ? path.split('/product/edit/complete/')[1] : undefined

  const [breadName, setBreadName] = useState<string>('')

  useEffect(() => {
    if (!id) return

    db.collection('breads')
      .doc(id)
      .get()
      .then((snapshot) => {
        const data = snapshot.data()
        if (!data || !('name' in data)) return
        setBreadName(data.name)
      })
  }, [id])

  return (
    <Layout title={id ? `完了｜${breadName}の編集` : '完了｜sacriで出品する商品の登録'}>
      <ProductEditCompleteTemplate />
    </Layout>
  )
}

export default ProductEditComplete
